import { call, put, takeLatest } from 'redux-saga/effects';
import { loginFailure, loginRequest, loginSuccess } from './authSlice';
import { authApiClient } from '../../utils/axios';

function* handleLogin(action) {
  try {
    const response = yield call(authApiClient.post, '/login', action.payload);
    const token = response.data.token;
    const subscription = response.data.current_subscription;
    localStorage.setItem('AUTH_TOKEN', token);
    localStorage.setItem('SUBSCRIPTION', JSON.stringify(subscription));
    yield put(loginSuccess(response.data));
  } catch (error) {
    yield put(loginFailure(error.response?.data?.errors?.message || 'Login failed'));
  }
}

export default function* loginSaga() {
  yield takeLatest(loginRequest.type, handleLogin);
}
